import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Platform-agnostic desktop shell for the desktop preview variants — the
 * counterpart to {@link MobileFrameComponent}. Draws the monitor bezel and the
 * browser window inside it, and clips whatever it wraps at the window edge so a
 * page taller than the viewport ends mid-element, the way the design mocks show
 * it.
 *
 * The bezel shrinks with the preview pane rather than scaling its contents: the
 * page inside is drawn at life size, so a narrower pane shows a narrower
 * browser window instead of a smaller one. See the desktop variants' styles for
 * why.
 */
@Component({
  selector: 'app-desktop-frame',
  standalone: true,
  templateUrl: './desktop-frame.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './desktop-frame.component.scss',
})
export class DesktopFrameComponent {}
